import axios from "axios";

function getBanThan(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/banthan");
};
function doiMatKhau(nhanVien){
    return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/doimatkhau",nhanVien);
  };
function capNhatThongTinCaNhan(nhanVien){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/capnhatthongtincanhan",nhanVien);
};
function xacThuc(){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/getrole");
};
function capNhatIDTelegram(key){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/capnhat-idtelegram",key);
};
function daNhanThongBao(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/taikhoan/danhan-thongbao");
};
const taiKhoanService={
    getBanThan,
    doiMatKhau,
    capNhatThongTinCaNhan,
    xacThuc,
    capNhatIDTelegram,
    daNhanThongBao
};
export default taiKhoanService;